import { preloadImage } from "@remotion/preload";
import { staticFile } from "remotion";


const preloadAudio = (src: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.src = src;
      audio.oncanplaythrough = () => resolve();
      audio.onerror = () => reject(new Error(`Failed to load audio: ${src}`));
    });
  };
  
  const preloadVideo = (src: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.src = src;
      video.onloadeddata = () => resolve();
      video.onerror = () => reject(new Error(`Failed to load video: ${src}`));
    });
  };

  
export const preloadResources = async (): Promise<void> => {
  const images = [
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_HAND.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_SMILE.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_PHONE_BIG.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_PHONE.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_ICON_1.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_ICON_2.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_ICON_3.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_ICON_4.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_ICON_5.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_ICON_6.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_PHONE.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/04_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/04_PHONE.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/05_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/05_PHONE_1.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/06_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/06_PHONE.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/07_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/07_PHONE.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/08_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/08_PHONE.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/10_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/11_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/11_MANO.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/11_PHONE.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/12_FONDO.jpg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/BOX_PORCENTAJE.png"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/BUBBLE_CARET.svg"),
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/circle-white-lines.svg"),
  ];
  const audios = [
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/Audio/pista_locucion_seekable.mp3"),
  ];

  const videos = [
    staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/animacion-Iphone.mp4"),
  ];

  const preloadPromises = [
    ...images.map((image) => preloadImage(image)),
    ...audios.map((audio) => preloadAudio(audio)),
    ...videos.map((video) => preloadVideo(video)),
  ];

  try {
    await Promise.all(preloadPromises);
    console.log("All resources preloaded successfully.");
  } catch (error) {
    console.error("Error preloading resources:", error);
  }
};